import { gql } from 'apollo-boost';

export const LIST_PROMOTERS = gql`
  query listPromoter {
    listPromoter {
      edges {
        node {
          id
          firstName
          lastName
          enabled
          isCoreConsultant
          isIntermediary
        }
      }
    }
  }
`;

export const LIST_LEADS_CHANNELS = gql`
  query listLeadsChannels {
    leadsChannels {
      name
      value
    }
  }
`;

export const LIST_LEADS_CHANNELS_DETAIL = gql`
  query listLeadsChannelsDetail {
    leadsChannelsDetail {
      name
      value
    }
  }
`;

export const LIST_LEADS_RANGES = gql`
  query listLeadsRanges {
    leadsRanges {
      name
      value
    }
  }
`;

export const LIST_LEADS_PRODUCTS = gql`
  query listLeadsProducts {
    leadsProducts {
      name
      value
    }
  }
`;

export const LIST_CANAL_ACTUAL = gql`
  query canalesActual {
    canalesActual {
      name
      value
    }
  }
`;

export const LIST_CANAL_ORIGEN = gql`
  query canalesOrigen {
    canalesOrigen {
      name
      value
    }
  }
`;

export const LIST_INTERESTED_INVESTORS = gql`
  query listClientsInterestedInvestors(
    $search: String
    $promoter: String
    $first: Int
    $last: Int
    $beforeCursor: String
    $afterCursor: String
  ) {
    listClients(
      state: "interested_investor"
      search: $search
      promoter: $promoter
      first: $first
      last: $last
      before: $beforeCursor
      after: $afterCursor
    ) {
      totalCount
      pageInfo {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
      }
      edges {
        node {
          id
          photoDocumentFront
          photoDocumentBack
          photoDocumentsUrl
          user {
            id
            firstName
            lastName
            maternalSurname
            email
            isActive
            isEmailAutogenerated
            documentType {
              id
              name
            }
            documentNumber
          }
          promoterCompany {
            id
            businessName
          }
          promoter {
            id
            firstName
            lastName
          }
          coreConsultant {
            id
            firstName
            lastName
          }
          state
          isRiskConsulted
          urlRiskReport
        }
      }
    }
  }
`;

export const GET_INTERESTED_INVESTOR_INFO = gql`
  query interestedInvestor($id: ID!) {
    client(id: $id) {
      id
      state
      sex
      photoDocumentFront
      photoDocumentBack
      enviarComunicacion
      nombreComunicacion
      nombreCanalActual
      nombreCanalOrigen
      correoIntermediario
      canalActual
      canalOrigen
      user {
        id
        firstName
        lastName
        maternalSurname
        email
        userType
        documentType {
          id
          name
        }
        documentNumber
        verificationDigit
      }
      promoterCompany {
        id
        businessName
      }
      promoter {
        id
        firstName
        lastName
      }
      coreConsultant {
        id
        firstName
        lastName
      }
      intermediaryPromoter {
        id
        firstName
        lastName
      }
      cellphone
      leadsRange
      leadsProducts {
        edges {
          node {
            id
            name
          }
        }
      }
    }
  }
`;

export const CREATE_USER_INTERESTED_INVESTORS = gql`
  mutation createUserInterestedInvestor($input: UserInput!) {
    createUser(input: $input) {
      user {
        id
        firstName
        lastName
        maternalSurname
        email
        isActive
        documentType {
          id
          name
        }
        documentNumber
        verificationDigit
        clientSet {
          edges {
            node {
              id
            }
          }
        }
      }
      error
    }
  }
`;

export const CREATE_USER_AND_CLIENT = gql`
  mutation createUserAndClient($input: UserAndClientInput!) {
    createUserAndClient(input: $input) {
      user {
        id
        firstName
        lastName
        maternalSurname
        email
        isActive
        userType
        documentType {
          id
          name
        }
        documentNumber
        verificationDigit
        clientSet {
          edges {
            node {
              id
              sex
              promoterCompany {
                id
                businessName
              }
              promoter {
                id
                firstName
                lastName
              }
              coreConsultant {
                id
                firstName
                lastName
              }
              intermediaryPromoter {
                id
                firstName
                lastName
              }
              enviarComunicacion
              nombreComunicacion
              nombreCanalActual
              nombreCanalOrigen
              correoIntermediario
              canalActual
              canalOrigen
              cellphone
              riskConsultingMessage
              state
              isRiskConsulted
              leadsRange
              leadsProducts {
                edges {
                  node {
                    id
                    name
                  }
                }
              }
            }
          }
        }
      }
      error
    }
  }
`;

export const UPDATE_USER_INTERESTED_INVESTORS = gql`
  mutation updateUserInterestedInvestor($id: ID!, $input: UserUpdateInput!) {
    updateUser(id: $id, input: $input) {
      user {
        id
        firstName
        lastName
        maternalSurname
        isStaff
        email
        userType
        documentType {
          id
        }
        documentNumber
        verificationDigit
      }
      errors {
        field
        message
      }
    }
  }
`;

export const UDPATE_CLIENT_INTERESTED_INVESTORS = gql`
  mutation updateClientInterestedInvestor($id: ID!, $input: ClientInput!) {
    updateClient(id: $id, input: $input) {
      client {
        id
        user {
          id
          firstName
          lastName
          maternalSurname
          email
          isActive
          userType
          documentType {
            id
            name
          }
          documentNumber
          verificationDigit
        }
        sex
        promoterCompany {
          id
          businessName
        }
        promoter {
          id
          firstName
          lastName
        }
        coreConsultant {
          id
          firstName
          lastName
        }
        intermediaryPromoter {
          id
          firstName
          lastName
        }
        enviarComunicacion
        nombreComunicacion
        nombreCanalActual
        nombreCanalOrigen
        correoIntermediario
        canalActual
        canalOrigen
        cellphone
        riskConsultingMessage
        state
        isRiskConsulted
        leadsRange
        leadsProducts {
          edges {
            node {
              id
              name
            }
          }
        }
      }
      errors {
        field
        message
      }
    }
  }
`;

export const DELETE_USER_INTERESTED_INVESTORS = gql`
  mutation deleteUserInvestor($id: ID!) {
    deleteUser(id: $id) {
      user {
        id
        firstName
        lastName
        maternalSurname
        email
        isActive
        documentType {
          id
          name
        }
        documentNumber
      }
      errors {
        field
        message
      }
    }
  }
`;

export const SEND_CREDENTIALS = gql`
  mutation sendCredentials($id: ID!) {
    sendCredentials(id: $id) {
      client {
        id
      }
      errors {
        field
        message
      }
    }
  }
`;

export const LIST_LEAD_PRODUCTS = gql`
  {
    listLeadProducts {
      edges {
        node {
          id
          name
        }
      }
    }
  }
`;
